import { render, staticRenderFns } from "./form_select_json.vue?vue&type=template&id=457e9274&scoped=true&lang=pug"
import script from "./form_select_json.vue?vue&type=script&lang=js"
export * from "./form_select_json.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457e9274",
  null
  
)

export default component.exports